import React, { useContext } from "react";
import { SiteContext } from "./global/site-context";
import clientConfig from "../../client-config";
import { Button } from "./button";

const attr = clientConfig.site.websiteParam;

const ctaMap = new Map([
  [
    "uncommon",
    {
      headline: "Join Uncommon",
      summary:
        "Share expertise, get product help, and connect with community and DevRel leaders.",
      href: `${clientConfig.site.joinSlackPath}?${attr}=call-to-action-inline`,
    },
  ],
  // @note swapped to all demo currently
  [
    "getStarted",
    {
      headline: clientConfig.site.demoPhrase,
      summary: "Fuel your growth, start building more pipeline.",
      href: `${clientConfig.site.demoPath}?${attr}=call-to-action-inline`,
      metric: "book-demo",
    },
  ],
  [
    "bookDemo",
    {
      headline: clientConfig.site.demoPhrase,
      summary:
        "See what the fastest-growing companies already know.",
      href: `${clientConfig.site.demoPath}?${attr}=call-to-action-inline`,
      metric: "book-demo",
    },
  ],
  [
    "contact",
    {
      headline: "Get in touch",
      summary: "Got questions? Let's chat.",
      href: `/contact/?${attr}=call-to-action-inline`,
    },
  ],
]);

export const CallToAction = ({ action }) => {
  const site = useContext(SiteContext);
  const cta = action && ctaMap.has(action) ? ctaMap.get(action) : null;

  return cta ? (
    <div>
      <a
        href={cta.href}
        className="block my-6 bg-green-emerald text-white group rounded-xl p-4 flex items-center hover:shadow-md scale-100 transform hover:scale-102 transition-size duration-200"
        onClick={() => {
          site.metrics.logClick("call-to-action-click", cta.metric || action);
        }}
      >
        <div className="flex-grow">
          <p className="font-medium">{cta.summary}</p>
        </div>
        <div className="flex-none ml-2 md:ml-8 lg:ml-12">
          <Button
            text={cta.headline}
            bgColor="bg-white"
            noLink={true}
            className="whitespace-nowrap text-white"
            noOpacity={true}
          />
        </div>
      </a>
    </div>
  ) : null;
};
